import React, { useState, useEffect } from "react";
import InventoryLotGrid from "./InventoryLotGrid";
import { Button } from "devextreme-react/button";

import data from "../../../../assets/apiRoutes.json";
import axios from "axios";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { InventoryItemRecord } from "./InventoryItemRecord"
import LocationsPopUp from "./LocationsPopUp";
import InventoryItemStatusPopUp from "./InventoryItemStatusPopUp";
import InventorySerialNamberPopUp from "./InventorySerialNamberPopUp";
import { useHistory } from 'react-router-dom';
import Toolbar, { Item } from "devextreme-react/toolbar";

const InventoryLot = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dataBase = props.ReceiptReducer.wmTransactionDatabase !== ""
    ? props.ReceiptReducer.wmTransactionDatabase
    : "";
  var accessToken = props.oidc.user.access_token;
  const [stateLocPopUp, setstateLocPopUp] = useState(false);
  const [stateStatusPopUp, setStateStatusPopUp] = useState(false);
  const [stateSerialNumberPopUp, setstateSerialNumberPopUp] = useState(false);
  const [locbtnDisable, setlocbtnDisable] = useState(true);
  const [statusbtnDisable, setStatusbtnDisable] = useState(true);
  const [SerialNumberBtnDisable, setSerialNumberBtnDisable] = useState(true);
  const [stateItemObj, setStateItemObj] = useState({});
  const [inventoryLotCodesData, setinventoryLotCodesData] = useState([]);
  const [inventoryItemCodeObj, setInventoryItemCodeObj] = useState({
    ItemCode: '',
    "Description-1": '',
    "Description-2": '',
    Status: '',
    Class: '',
    SubClass: '',
    itemRowid: location?.state?.detail,
  });
  const [inventoryLotCodesObj, setinventoryLotCodesObj] = useState({
    lotDescription1: "",
    itemDescription1: "",
    customerName: "",
    lotCode: "",
    itemCode: "",
    itemRowid: location?.state?.detail,
    dbName: dataBase
  });
  const handleCallback = (ChildData) => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.Item.GetItemByRowid}`, { itemRowid: ChildData.itemRowid },
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        res.data.lotRowid = ChildData.lotRowid;
        setStateItemObj(res.data);
        setlocbtnDisable(false);
        setSerialNumberBtnDisable(false);
        setStatusbtnDisable(false);
      });
  };
  const handlEnableDisableLocBtn = (ChildData) => {
    setlocbtnDisable(ChildData);
  };
  const handlEnableDisableStatusBtn = (ChildData) => {
    setStatusbtnDisable(ChildData);
  };

  const handlEnableDisableSerialNumberBtn = (ChildData) => {
    setSerialNumberBtnDisable(ChildData);
  };
  const handleClosePopUpCallback = (ChildData) => {
    setstateLocPopUp(ChildData);
  };
  const handleStatusPopUpCloseCallback = (ChildData) => {
    setStateStatusPopUp(ChildData);
  };
  const handleSerialNumberClosePopUpCallback = (ChildData) => {
    setstateSerialNumberPopUp(ChildData);
  };
  const openLocations = (e) => {
    if (stateItemObj) {
      setstateLocPopUp(true);
    }
  };
  const openSerialnumberPopUp = (e) => {
    if (stateItemObj) {
      setstateSerialNumberPopUp(true);
    }
  };
  const openStatus = (e) => {
    if (stateItemObj) {
      setStateStatusPopUp(true);
    }
  };
  const loadInventoryLotData = () => {
    axios
      .get(`${window._env_.REACT_APP_APIS}/${data.Lot.GetAllLots}?itemRowid=` + inventoryLotCodesObj.itemRowid,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        setinventoryLotCodesData(res.data.data);
      });
  };
  const loadItemData = () => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.Item.GetItemByRowid}`, inventoryItemCodeObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        setInventoryItemCodeObj(res.data);
      });
  };
  const Back = () => {
    history.push({
      pathname: '/wm/inventory-items'
    });
    return;
  };
  useEffect(() => {
    loadInventoryLotData();
    loadItemData();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <Toolbar>
            <Item location="before">
              <div className="title" style={{paddingLeft:'10px'}}>
                <h6 style={{ color: window._env_.Color2 }}>
                  Lots
                </h6>
              </div>
            </Item>
            <Item location="after"style={{paddingRight:'10px'}}>
              <Button onClick={Back} text="Back" icon="back" />
            </Item>
          </Toolbar>
        </div>
      </div>
      {/* Inventory Item Info */}
      <div className="row mb-3">
        <div className="col-md-12">
          <InventoryItemRecord itemObj={inventoryItemCodeObj} />
        </div>
      </div>

      {/* Inventory Grid */}
      <div className="row">
        <div className="col-md-12">
          <InventoryLotGrid
            data={inventoryLotCodesData}
            accessToken={accessToken}
            parentCallback={handleCallback}
            enableDisableLocBtn={handlEnableDisableLocBtn}
            enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
            enableDisableStatusBtn={handlEnableDisableStatusBtn}
            locbtnDisable={locbtnDisable}
            openLocations={openLocations}
            SerialNumberBtnDisable={SerialNumberBtnDisable}
            openSerialnumberPopUp={openSerialnumberPopUp}
            statusbtnDisable={statusbtnDisable}
            openStatus={openStatus}
          />
        </div>
      </div>

      {/* Location Pop-up */}
      {stateLocPopUp && (
        <LocationsPopUp
          itemObj={stateItemObj}
          visibility={stateLocPopUp}
          parentCallback={handleClosePopUpCallback}
        />
      )}

      {/* Serial Number Pop-up */}
      {stateSerialNumberPopUp && (
        <InventorySerialNamberPopUp
          itemObj={stateItemObj}
          visibility={stateSerialNumberPopUp}
          parentCallback={handleSerialNumberClosePopUpCallback}
        />
      )}

      {/* Status Pop-up */}
      {stateStatusPopUp && (
        <InventoryItemStatusPopUp
          itemObj={stateItemObj}
          visibility={stateStatusPopUp}
          parentCallback={handleStatusPopUpCloseCallback}
        />
      )}
    </div>
  );

};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(InventoryLot);